import { InjectionToken } from '@angular/core';

import projectConfig from '../../../project.json';

export const SSO_PRODUCT_VERSION = new InjectionToken<string>('SSO Product Version', { factory: () => 'sso@' + projectConfig.version });
